var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBackTen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_21120_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99089 4.16668V0.833344L5.82422 5.00001L9.99089 9.16668V5.83334C12.7492 5.83334 14.9909 8.07501 14.9909 10.8333C14.9909 13.5917 12.7492 15.8333 9.99089 15.8333C7.23255 15.8333 4.99089 13.5917 4.99089 10.8333H3.32422C3.32422 14.5167 6.30755 17.5 9.99089 17.5C13.6742 17.5 16.6576 14.5167 16.6576 10.8333C16.6576 7.15001 13.6742 4.16668 9.99089 4.16668Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_21120_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07344 13.3333H8.3651V10.6167L7.52344 10.875V10.3L8.99844 9.77499H9.07344V13.3333Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_21120_338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6388 11.8667C12.6388 12.1333 12.6138 12.3667 12.5555 12.55C12.4971 12.7333 12.4138 12.9 12.3138 13.025C12.2138 13.15 12.0805 13.2417 11.9388 13.3C11.7971 13.3583 11.6305 13.3833 11.4471 13.3833C11.2638 13.3833 11.1055 13.3583 10.9555 13.3C10.8055 13.2417 10.6805 13.15 10.5721 13.025C10.4638 12.9 10.3805 12.7417 10.3221 12.55C10.2638 12.3583 10.2305 12.1333 10.2305 11.8667V11.25C10.2305 10.9833 10.2555 10.75 10.3138 10.5667C10.3721 10.3833 10.4555 10.2167 10.5555 10.0917C10.6555 9.96667 10.7888 9.875 10.9305 9.81667C11.0721 9.75834 11.2388 9.73334 11.4221 9.73334C11.6055 9.73334 11.7638 9.75834 11.9138 9.81667C12.0638 9.875 12.1888 9.96667 12.2971 10.0917C12.4055 10.2167 12.4888 10.375 12.5471 10.5667C12.6055 10.7583 12.6388 10.9833 12.6388 11.25V11.8667ZM11.9305 11.15C11.9305 10.9917 11.9221 10.8583 11.8971 10.75C11.8721 10.6417 11.8388 10.5583 11.7971 10.4917C11.7555 10.425 11.7055 10.375 11.6388 10.35C11.5721 10.325 11.5055 10.3083 11.4305 10.3083C11.3555 10.3083 11.2805 10.325 11.2221 10.35C11.1638 10.375 11.1055 10.425 11.0638 10.4917C11.0221 10.5583 10.9888 10.6417 10.9638 10.75C10.9388 10.8583 10.9305 10.9917 10.9305 11.15V11.9583C10.9305 12.1167 10.9388 12.25 10.9638 12.3583C10.9888 12.4667 11.0221 12.5583 11.0638 12.625C11.1055 12.6917 11.1555 12.7417 11.2221 12.7667C11.2888 12.7917 11.3555 12.8083 11.4305 12.8083C11.5055 12.8083 11.5805 12.7917 11.6388 12.7667C11.6971 12.7417 11.7555 12.6917 11.7971 12.625C11.8388 12.5583 11.8721 12.4667 11.8888 12.3583C11.9055 12.25 11.9221 12.1167 11.9221 11.9583V11.15H11.9305Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_21120_338",
    x: 2.32422,
    y: 0.833344,
    width: 15.332,
    height: 18.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21120_338"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21120_338",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_21120_338",
    x: 6.52344,
    y: 9.77499,
    width: 3.55078,
    height: 5.55832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21120_338"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21120_338",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_21120_338",
    x: 9.23047,
    y: 9.73334,
    width: 4.41016,
    height: 5.64999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21120_338"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21120_338",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackTen);
export default __webpack_public_path__ + "static/media/icon-back-ten.a2f67823e64dad2e65866f437d30b706.svg";
export { ForwardRef as ReactComponent };